import React from 'react';
import { Container, Col, Row } from "reactstrap"
import { addBodyClasses } from "../utils";
import OnboardingMetaTags from "../../components/OnboardingMetaTags";

const queryString = require('query-string');

function WebRetroLanding() {
  const parsed = queryString.parse(window.location.search);
  const source = parsed.source || '';

  addBodyClasses(['web-retro-landing-page'])();

  const jobURL = `https://survey.alchemer.com/s3/7469527/Web-Retro-Screen-Time-Test?source=${source}`;

  return (
    <Container fluid="sm">
      <OnboardingMetaTags title="Share data, earn immediately" />
      <Row>
        <Col>
          <div className="splash-image">
            <img
              alt="Have fun with MSR!"
              src="/img/splash-twin-phones.png"
            />
          </div>
          <p>Hi there,</p>
          <p>We’re a research company called <a href="http://www.measureprotocol.com">Measure</a> and we’re running a study on how people use their iPhone.</p>
          <p>Instead of long, boring surveys, we collect data from screen recordings. Everything is anonymized and your privacy is protected.</p>
          <p>For this study, <span className="highlight">we’ll pay you $3 now</span>, or you can choose to install our app at the end and we’ll <span className="highlight">double that to $6</span>.</p>
          <div className="action-button">
            <a className="btn btn-primary" href={jobURL}>Start now</a>
          </div>
          <p className="terms">
            <a href="https://contributor.measureprotocol.com/app/terms">Terms and Conditions</a>
          </p>
        </Col>
      </Row>
    </Container>
  );
}

export default WebRetroLanding;
